const getAdvertisementImgKeyArray = (imageURLs, images) => {
    const imgKeyArray = Object.keys(imageURLs)

    if(images) {
        imgKeyArray.map(key => {
            if(images.hasOwnProperty(key) && images[key] && images[key].url) {
                imageURLs[key] = images[key].url
            }
        })
    }

    return imgKeyArray
}

export default getAdvertisementImgKeyArray